import { render } from "./TabTransport.vue?vue&type=template&id=2071b41e&ts=true"
import script from "./TabTransport.vue?vue&type=script&lang=ts"
export * from "./TabTransport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__